package pwgs.ui.scenes.trialsettingsscene


class TrialSettingsControllerFe(props: TrialSettingsSceneProps, scene: MTrialSettingsScene) : ATrialSettingsControllerFe(props, scene) {

    override fun createInitialModel() : TrialSettingsSceneModel {
        return TrialSettingsSceneModel("", 0)
    }

    override fun init() {
        call_load()
    }

    fun startTrialSeason(days: Int) {
        this.model.isLoading = true
        this.render()

        call_startTrialSeason(days)
    }

    fun stopTrialSeason() {
        this.model.isLoading = true
        this.render()

        call_stopTrialSeason()
    }

}

